import React, { useState } from "react";
import { Button, Input, InputGroup, InputGroupAddon, ListGroup, ListGroupItem, Spinner } from "reactstrap";

import { apiFetch, API, withMarket } from "../../services/api";
import { CATEGORIES, SLOT_LABELS } from "../../helpers/studioStory";

const thumb = (p) => (p.bestDeclinations && p.bestDeclinations.firstImg) || ((p.declinations || []).find((d) => d.firstImg) || {}).firstImg || "";
const slugOf = (p) => p.shortURL || p.slug || "";

// Recherche d'un produit pour un emplacement de la story (même API que la liste produits),
// dans la catégorie choisie.
export function ProductPicker({ slot, locale, value, onChange, category, onCategory, suggestions }) {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const search = () => {
        if (!query.trim()) return;
        setBusy(true); setError(null);
        // Même appel que la recherche de la liste produits (components/ProductsList.js) : POST sans corps.
        apiFetch(withMarket(API.products + "/products?headCategory=" + category + "&keywords=" + encodeURIComponent(query.trim().toLowerCase().replace(/\s+/g, "-")), locale || "fr"), { method: "POST" })
            .then((res) => { if (!res.ok) throw new Error("HTTP " + res.status); return res.json(); })
            // Réponse paginée : { products, lastEvaluatedKey }.
            .then((data) => { const list = Array.isArray(data) ? data : (data && data.products) || []; setResults(list.filter((p) => p.active !== false && slugOf(p)).slice(0, 8)); })
            .catch((e) => setError("Recherche impossible (" + e.message + ")"))
            .finally(() => setBusy(false));
    };

    return (
        <div className="mb-3">
            <strong>{SLOT_LABELS[slot]}</strong>
            {value && <div className="small text-muted mb-1">Choisi : {value.name} <code>{value.slug}</code> <Button size="sm" color="link" onClick={() => onChange(null)}>retirer</Button></div>}
            {suggestions && suggestions.length > 0 && (
                <div className="mb-1">
                    <small className="text-muted mr-1">Propositions du jour :</small>
                    {suggestions.map((s) => (
                        <Button key={s.slug} size="sm" color={value && value.slug === s.slug ? "primary" : "light"} className="mr-1 mb-1" onClick={() => onChange(s)}>
                            {s.name} <small>({s.label})</small>
                        </Button>
                    ))}
                </div>
            )}
            <InputGroup size="sm">
                <InputGroupAddon addonType="prepend">
                    <Input type="select" bsSize="sm" value={category} onChange={(e) => { onCategory(e.target.value); setResults(null); }} aria-label="Catégorie">
                        {CATEGORIES.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
                    </Input>
                </InputGroupAddon>
                <Input placeholder="Rechercher (ex. pegasus 41)" value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} />
                <InputGroupAddon addonType="append"><Button color="secondary" onClick={search} disabled={busy}>{busy ? <Spinner size="sm" /> : "Rechercher"}</Button></InputGroupAddon>
            </InputGroup>
            {error && <div className="small text-danger">{error}</div>}
            {results && (
                <ListGroup className="mt-1" style={{ maxHeight: 260, overflowY: "auto" }}>
                    {results.length === 0 && <ListGroupItem className="small">Aucun produit actif trouvé.</ListGroupItem>}
                    {results.map((p) => (
                        <ListGroupItem key={slugOf(p)} action tag="button" className="d-flex align-items-center small"
                            onClick={() => { onChange({ slug: slugOf(p), name: p.name }); setResults(null); }}>
                            {thumb(p) ? <img src={thumb(p)} alt="" style={{ width: 36, height: 36, objectFit: "contain", marginRight: 8 }} /> : null}
                            <span>{p.name}</span>
                            <span className="ml-auto text-muted">{p.bestDeclinations && p.bestDeclinations.price ? p.bestDeclinations.price + " €" : ""}</span>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            )}
        </div>
    );
}
